export default __webpack_public_path__ + "static/media/indicator-quote5.e666d289.svg";